import axiosInstance from "./axiosInstance";

export const POOL_TYPES = {
  APPROVAL: "APPROVAL",
  SCAM: "SCAM",
};

export const APPROVAL_ACTIONS = {
  APPROVED: "APPROVED",
  UNIDENTIFIED_APPROVED: "UNIDENTIFIED_APPROVED",
  DISAPPROVED: "DISAPPROVED",
  SHADOW_BAN: "SHADOW_BAN",
  PERMANENT_BAN: "PERMANENT_BAN",
  DEFER: "DEFER",
};

const basePath = "/management/v2/pools/members/";

export async function fetchPoolMembers(params = {}, headers = {}) {
  return axiosInstance.django.get(basePath, {
    params: {
      max_count: 30,
      ...params,
    },
    headers,
  });
}

export async function updateUserApproval(body, params = {}, headers = {}) {
  return axiosInstance.django.post(basePath, body, {
    params,
    headers,
  });
}
